import React, { Component } from "react";
import { Route } from "react-router";
import Header from "./Header";
import Footer from "./Footer";
import banner_img from "../../images/banner-profile.jpg";
import { API_TOKEN_NAME, IMAGE_URL, SITE_URL } from "../../constants";
import { scAxiosAdmin } from "../..";
import { Helmet } from "react-helmet";
import case_under from "../../images/case_under.png";
import SEO from "../../component/Seo";

const getNews = (page) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/newsevents/getallnewsevents?page=" + page,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
        params: {},
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class LatestNews extends Component {
  state = {
    news: [],
    nextLink: "",
    previousLink: "",
    currentPage: "",
    nextPage: 5,
  };

  refreshNews = (event) => {
    let page = this.props.match.params["page"];

    getNews(page)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          let nextPageNo = Number(records.current_page) + 1;
          this.setState({
            news: records.data,
            nextLink: records.links[2],
            previousLink: records.links[1],
            currentPage: records.current_page,
            nextPage: nextPageNo,
          });
          if (records.data.length == 0) {
            window.location.href = "/news";
          }
        } else {
          this.setState({ news: "" });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    this.refreshNews();
  }
  render() {
    return (
      <div>
        <SEO
          title={
            "News | United Hospital Bangladesh | Best Hospital In Bangladesh"
          }
          description={"Photo Gallery of United Hospital Bangladesh Limited"}
          pathSlug="/gallery/photo-gallery"
          keywords="newsevents, Singlenewsevents"
        />
        <Route component={Header} />
        <div
          id="giveMargin"
          className=""
          style={{ backgroundColor: "#fef3e9" }}
        >
          <img src={banner_img} alt="banner-profile" className="w-100" />
          <section className="termscondbody pb-3">
            <div className="container p-3">
              <div className="w-100 d-flex justify-content-center align-items-center flex-column py-4">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    flexDirection: "column",
                    marginBottom: "5px",
                    // margin: "0 auto",
                  }}
                >
                  <h3
                    className="text-center"
                    style={{
                      color: "#0C807D",
                      fontSize: "28px",
                      fontWeight: "500",
                      
                    }}
                  >
                    NEWS & EVENTS
                  </h3>
                  {/* <img src="/assets/images/department_under.png" alt="" /> */}
                </div>
              </div>
              {/* <h3
                className="text-center pb-5 text-center"
                style={{
                  color: "#0C807D",
                  fontWeight: "700",
                  width: "100%",
                }}
              >
                NEWS & EVENTS
              </h3> */}
              <div className="row w-100 justify-content-between g-4">
                {this.state.news.map((single) => {
                  return [
                    <div
                      className="col-12 col-sm-12 col-md-6 col-lg-6"
                      style={{ height: "490px" }}
                    >
                      <div
                        className="card w-100 p-3 d-flex flex-column align-items-center h-100"
                        style={{ borderRadius: "10px" }}
                      >
                        <div className="w-100 h-50">
                          <img
                            style={{
                              objectFit: "cover",
                              height: "100%",
                              width: "100%",
                              borderRadius: "10px",
                            }}
                            src={
                              IMAGE_URL +
                              "NewsEventsImg/" +
                              single.news_events_pic
                            }
                            alt=""
                            // width={475}
                            // height={267}
                          />
                        </div>
                        <div className=" mt-3 w-100" key={single.id}>
                          <div
                            className="d-flex pt-3 px-3 pb-3"
                            style={{ backgroundClip: "#E7F2F2" }}
                          >
                            <img
                              src={case_under}
                              alt=""
                              width={3}
                              height={70}
                            />
                            <div className="d-flex flex-column">
                              <h3
                                className="px-4 pt-2"
                                style={{
                                  fontSize: "22px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {single.news_events_title.slice(0, 30) + " ..."}
                              </h3>
                              <p
                                className="px-4 pt-2 text-secondary mt-3"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    single.news_events_desc.slice(0, 60) +
                                    " ...",
                                }}
                              ></p>
                              <a
                                className="px-4 pt-2 text-secondary mt-3"
                                href={SITE_URL + "/news/" + single.Slug}
                              >
                                <button
                                  style={{
                                    fontSize: "16px",
                                    width: "118px",
                                    height: "43px",
                                    backgroundColor: "#0C807D",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    borderRadius: "6px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Details
                                </button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>,
                  ];
                })}

                {this.state.nextLink.url && (
                  <a
                    href={
                      SITE_URL + "/news/page/" + `${this.state.currentPage + 1}`
                    }
                  >
                    Next
                  </a>
                )}
                {this.state.previousLink.url && this.state.currentPage != 1 && (
                  <a
                    href={
                      SITE_URL + "/news/page/" + `${this.state.currentPage - 1}`
                    }
                  >
                    Previous
                  </a>
                )}
              </div>
            </div>
          </section>
        </div>
        <Route component={Footer} />
      </div>
    );
  }
}
export default LatestNews;



// WEBPACK FOOTER //
// ./src/component/frontend/LatestNews.js